import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {PickListTransferControls} from './PickListTransferControls';
import SelectorGrid from "../SelectorGrid/SelectorGrid";
import isEqual from "lodash-es/isEqual";

export class PickList extends Component {

    static defaultProps = {
        id: null,
        source: {
            rows: [],
            cols: []
        },
        target: {
            rows: [],
            cols: []
        },
        sourceHeader: null,
        targetHeader: null,
        style: null,
        className: null,
        sourceStyle: null,
        targetStyle: null,
        responsive: false,
        showSourceControls: true,
        showTargetControls: true,
        metaKeySelection: true,
        itemTemplate: null,
        onChange: null,
        onMoveToSource: null,
        onMoveAllToSource: null,
        onMoveToTarget: null,
        onMoveAllToTarget: null,
        emptyMessage: "Nincs találat",
    }

    static propsTypes = {
        id: PropTypes.string,
        source: PropTypes.shape(SelectorGrid.propTypes),
        target: PropTypes.shape(SelectorGrid.propTypes),
        sourceHeader: PropTypes.string,
        targetHeader: PropTypes.string,
        style: PropTypes.object,
        className: PropTypes.string,
        sourcestyle: PropTypes.object,
        targetstyle: PropTypes.object,
        responsive: PropTypes.bool,
        showSourceControls: PropTypes.bool,
        showTargetControls: PropTypes.bool,
        metaKeySelection: PropTypes.bool,
        itemTemplate: PropTypes.func,
        onChange: PropTypes.func,
        onMoveToSource: PropTypes.func,
        onMoveAllToSource: PropTypes.func,
        onMoveToTarget: PropTypes.func,
        onMoveAllToTarget: PropTypes.func,
        emptyMessage: PropTypes.string,
        onTransferItems: PropTypes.func
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedItemsSource: [],
            selectedItemsTarget: []
        };
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {...this.state};
        let changed = false;
        if(!isEqual(prevProps.target.selection, this.props.target.selection)) {
            state.selectedItemsTarget = prevProps.target.selection;
            changed = true;
        }
        if(!isEqual(prevProps.source.selection, this.props.source.selection)) {
            state.selectedItemsSource = prevProps.source.selection;
            changed = true;
        }
        changed && this.promisedSetState(state);
    }

    handleChange = async (event, source, target) => {
        if (this.props.onChange) {
            await this.props.onChange({
                event: event.originalEvent,
                source: source,
                target: target,
            });
        }
        if (this.props.saveChanges) {
            await this.props.saveChanges(this.props.name, target);
        }
    }

    onTransfer = async (event) => {
        try {
            let source = this.state.selectedItemsSource;
            if (!Array.isArray(source)) {
                source = [source];
            }
            let target = this.state.selectedItemsTarget;
            if (!Array.isArray(target)) {
                target = [target];
            }
            switch (event.direction) {
                case 'toTarget':
                    if (this.props.onMoveToTarget) {
                        source = await this.props.onMoveToTarget({
                            originalEvent: event.originalEvent,
                            value: source
                        })
                    }
                    const convert = this.props.target.convert || ((item) => item);
                    source = await Promise.all(source.map(async (item) => await convert(JSON.parse(JSON.stringify(item)))));
                    /*const idKey = this.props.idKey || "id";
                    target = [...this.props.target.rows];
                    target = target.concat(source);*/
                    if (this.props.onTransferItems) {
                        await this.props.onTransferItems(event, source);
                    }
                    break;

                case 'allToTarget':
                    if (this.props.onMoveAllToTarget) {
                        await this.props.onMoveAllToTarget({
                            originalEvent: event.originalEvent,
                            value: this.state.source.data.rows
                        })
                    }
                    break;

                case 'toSource':
                    if (this.props.onMoveToSource) {
                        await this.props.onMoveToSource({
                            originalEvent: event.originalEvent,
                            value: target
                        })
                    }
                    if (this.props.onTransferItems) {
                        await this.props.onTransferItems(event, target);
                    }
                    break;

                case 'allToSource':
                    if (this.props.onMoveAllToSource) {
                        await this.props.onMoveAllToSource({
                            originalEvent: event.originalEvent,
                            value: this.props.target.rows
                        })
                    }
                    break;

                default:
                    break;
            }

            await this.promisedSetState({
                selectedItemsSource: [],
                selectedItemsTarget: []
            });
            await this.handleChange(event, source, target);
        } catch (e) {
            console.error(e);
        }
    }

    onSourceItemUpdate = async (item, oldItem, field) => {
        try {
            if (this.props.onSourceItemUpdate) {
                return await this.props.onSourceItemUpdate(item, oldItem, field);
            }
            return true;
        } catch (e) {
            throw e;
        }
    }

    onTargetItemUpdate = async (item, oldItem, field) => {
        try {
            if (this.props.onTargetItemUpdate) {
                return await this.props.onTargetItemUpdate(item, oldItem, field);
            }
            return true;
        } catch (e) {
            throw e;
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    refresh = () => {
        this.source && this.source.refresh();
        this.target && this.target.refresh();
    }

    refreshBackground = () => {
        this.source && this.source.refreshBackground();
        this.target && this.target.refreshBackground();
    }

    render() {
        let className = classNames('picklist', this.props.className, {});
        return (
            <div id={this.props.id} className={className} style={this.props.style}>

                {(this.props.source.visible === undefined || this.props.source.visible) && <SelectorGrid
                    loading={this.props.loading || this.props.source.loading}
                    disabled={this.props.disabled || false}
                    ref={(el) => this.source = el}
                    data={this.props.data}
                    selectionMode="single"
                    //virtualScroll={true}
                    //virtualRowHeight={30}
                    selection={this.state.selectedItemsSource}
                    {...this.props.source}
                    onItemUpdate={this.onSourceItemUpdate}
                    onSelectionChange={(e) => {
                        let items = this.props.source.onSelectionChange && this.props.source.onSelectionChange(e);
                        if (Array.isArray(items) || (typeof items === "object" && items !== null)) {
                            if (Array.isArray(items) && (this.props.source.selectionMode || "single") === "single") {
                                items = items.shift();
                            }
                            this.setState({selectedItemsSource: items});
                        } else {
                            this.props.source.selection === undefined && this.setState({selectedItemsSource: e.value});
                        }
                    }}
                />}

                {(this.props.control === undefined || (this.props.control && (this.props.control.visible === undefined || this.props.control.visible))) && <PickListTransferControls
                    disabled={this.props.disabled || this.props.loading}
                    onTransfer={this.onTransfer} source={[]} target={[]}
                    sourceSelection={this.state.selectedItemsSource}
                    targetSelection={this.state.selectedItemsTarget}
                    visible={(this.props.source.visible === undefined || this.props.source.visible) && (this.props.target.visible === undefined || this.props.target.visible) }
                    sourceButton={this.props.source.selection === undefined}
                    targetButton={this.props.target.selection === undefined}
                >
                    {this.props.controlButtons}
                </PickListTransferControls>}

                {(this.props.target.visible === undefined || this.props.target.visible) && <SelectorGrid
                    loading={this.props.loading || this.props.target.loading}
                    disabled={this.props.disabled || false}
                    ref={(el) => this.target = el}
                    data={this.props.data}
                    selectionMode="single"
                    //virtualScroll={true}
                    //virtualRowHeight={30}
                    selection={this.state.selectedItemsTarget}
                    {...this.props.target}
                    onItemUpdate={this.onTargetItemUpdate}
                    onSelectionChange={(e) => {
                        let items = this.props.target.onSelectionChange && this.props.target.onSelectionChange(e);
                        if (Array.isArray(items) || (typeof items === "object" && items !== null)) {
                            if (Array.isArray(items) && (this.props.target.selectionMode || "single") === "single") {
                                items = items.shift();
                            }
                            this.setState({selectedItemsTarget: items});
                        } else {
                            this.props.target.selection === undefined && this.setState({selectedItemsTarget: e.value});
                        }
                    }}
                />}

            </div>
        );
    }
}

export default PickList;